import ApiClient from '../ApiClient';

class CrmContactTimelineAPI extends ApiClient {
    constructor() {
        super('crm/contacts', { accountScoped: true });
    }

    getTimeline(contactId, page = 1, per = 25) {
        return axios.get(`${this.url}/${contactId}/timeline`, {
            params: { page, per },
        });
    }

    getJourneys(contactId) {
        return axios.get(`${this.url}/${contactId}/journeys`);
    }
}
export default new CrmContactTimelineAPI();
